import { Component, ChangeDetectionStrategy, AfterViewInit, QueryList, ViewChildren, ElementRef } from '@angular/core';

import { TranslateDirective } from '../directives/translate.directive';
import { TranslateService } from '../services/translate.service';

@Component({
	selector: 'load-additional-translations',
	styleUrls: ['./translate.component.scss'],
	templateUrl: './translate.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TranslateComponent implements AfterViewInit {
	@ViewChildren(TranslateDirective) elements: QueryList<TranslateDirective>;

	constructor(private _translateService: TranslateService, private _el: ElementRef) {}

	ngAfterViewInit(): void {
		this.elements.toArray().forEach(element => {
			this._translateService.add(
				element.trans,
				element.el.nativeElement.innerHTML
			);

			this._el.nativeElement.removeChild(element.el.nativeElement);
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/i18n/components/translate.component.ts